import Maybe from 'components/__new/common/Maybe';
import ModalAlert from 'components/__new/common/ModalAlert copy';
import PinModal from 'components/__new/common/PinModal';
import useAccessPinStatus from 'hooks/useAccessPinStatus';
import useLoginInfo from 'hooks/useLoginInfo';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { createAccessPin, createAccessPinEmployerAdmin, createAccessPinReset, generateOtp, generateOtpEmployerAdmin, generateOtpReset, getDashboard } from 'store/entities/wallet/action';
import maskEmailAddress from 'utils/maskData';

const AccessPinModals = ({
    loading,
    isOpenPin,
    setIsOpenPin,
    pin,
    setPin,
    onSubmit,
    resetPins,
    setIsOpenAccessPin,
    isOpenNewAccessPin,
    setIsOpenNewAccessPin,
    isOpenConfirmAccessPin,
    setIsOpenConfirmAccessPin,
    isOpenOtpNewPin,
    setIsOpenOtpNewPin,
    isOpenModalAlertTransferSuccess,
    setIsOpenModalAlertTransferSuccess,
    isOpenModalAlertNewPinSuccess,
    setIsOpenModalAlertNewPinSuccess,
}) => {
    const dispatch = useDispatch();
    const {userInfo, updateIsAccessPinSet} = useLoginInfo();
    const {getAccessPinStatus} = useAccessPinStatus();
    const {
        dashboardLoading,
        dashboard,
        otpGenerationLoading,
        otpGeneration,
        accessPinLoading,
        accessPin
    } = useSelector((s) => s.entities.wallet);
    
    
    useEffect(() => {
        // if (otpGeneration?.status === "success"){
        if (otpGeneration?.error === false){
            const hasAccessPin = getAccessPinStatus(dashboard);
            if (hasAccessPin === null || hasAccessPin === false){
                setIsOpenConfirmAccessPin(false);
                setIsOpenOtpNewPin(true);
            }
            dispatch(generateOtpReset());
        }
        // eslint-disable-next-line
    }, [otpGeneration])
    
    
    useEffect(() => {
        // if (accessPin?.status === "success"){
        if (accessPin?.status === "success"){
            setIsOpenOtpNewPin(false);
            setIsOpenModalAlertNewPinSuccess(true);
            resetPins();
            dispatch(createAccessPinReset());
            dispatch(getDashboard(userInfo));
            // updateIsAccessPinSet(true);
        }
        // eslint-disable-next-line
    }, [accessPin])

    
    return (
        <Maybe condition={dashboard?.status === "success"}>
            <>

                <PinModal
                    target="Access Pin"
                    title="Validate Transfer"
                    description="Enter Access Pin"
                    pin={(e) => setPin({...pin, accessPin: e})}
                    submit={onSubmit}
                    loading={loading}
                    modalLoading={dashboardLoading}
                    isOpenPin={isOpenPin}
                    setIsOpenPin={setIsOpenPin}
                    showForgotPin={true}
                />


                <ModalAlert
                    successText="Congratulations! Recurring payment created successfully"
                    dismissText="Close"
                    isOpenModalAlert={isOpenModalAlertTransferSuccess}
                    setIsOpenModalAlert={setIsOpenModalAlertTransferSuccess}
                />


                <PinModal
                    target="Access Pin"
                    title="Create Access Pin"
                    description="Set new access pin"
                    pin={(e) => setPin({...pin, accessPin: e})}
                    submit={() => {
                        setIsOpenNewAccessPin(false);
                        setIsOpenConfirmAccessPin(true);
                    }}
                    loading={false}
                    modalLoading={dashboardLoading}
                    isOpenPin={isOpenNewAccessPin}
                    setIsOpenPin={setIsOpenNewAccessPin}
                />


                <PinModal
                    target="Access Pin"
                    title="Confirm Access Pin"
                    description="Please re-enter your access pin"
                    pin={(e) => setPin({...pin, accessPinConfirm: e})}
                    submit={() => {
                        if (pin.accessPin === pin.accessPinConfirm){
                            if (userInfo.employer.userType === "employer"){
                                dispatch(generateOtp(userInfo.token, "access-pin"));
                            }
                            else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                dispatch(generateOtpEmployerAdmin(null, 'access-pin'));
                            }
                        }
                        else{
                            toast.error("Your access pin does not match");
                        }
                    }}
                    loading={otpGenerationLoading}
                    modalLoading={dashboardLoading}
                    isOpenPin={isOpenConfirmAccessPin}
                    setIsOpenPin={setIsOpenConfirmAccessPin}
                />


                <PinModal
                    target="OTP"
                    title="Enter OTP"
                    description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email) + ", to create your new access pin"}
                    pin={(e) => setPin({...pin, otp: e})}
                    submit={() => {
                        const params = {otp: parseInt(pin.otp), accessPin: pin.accessPin}
                        if (userInfo.employer.userType === "employer"){
                            dispatch(createAccessPin(userInfo.token, params));
                        }
                        else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                            dispatch(createAccessPinEmployerAdmin(params));
                        }
                    }}
                    loading={accessPinLoading}
                    modalLoading={otpGenerationLoading}
                    isOpenPin={isOpenOtpNewPin}
                    setIsOpenPin={setIsOpenOtpNewPin}
                />


                <ModalAlert
                    successText="Access Pin created successfully"
                    dismissText="Back to transfer"
                    isOpenModalAlert={isOpenModalAlertNewPinSuccess}
                    setIsOpenModalAlert={setIsOpenModalAlertNewPinSuccess}
                    submit={() => {
                        setIsOpenModalAlertNewPinSuccess(false);
                        setIsOpenAccessPin(true);
                    }}
                />
                
            </>
        </Maybe>
    )
}

export default AccessPinModals
